import { render, staticRenderFns } from "./TestSummary.vue?vue&type=template&id=5fd4151b"
import script from "./TestSummary.vue?vue&type=script&lang=js"
export * from "./TestSummary.vue?vue&type=script&lang=js"
import style0 from "./TestSummary.vue?vue&type=style&index=0&id=5fd4151b&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports